// material
import { styled } from '@mui/material/styles';
import { Stack, Container, Typography } from '@mui/material';
// components
import Page from '../../components/styled-components/Page';
import { EditProfileForm } from '../../components/profile';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex'
  }
}));

const ContentStyle = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  display: 'flex',
  minHeight: '100vh',
  flexDirection: 'column',
  justifyContent: 'center',
  padding: theme.spacing(1.5, 0)
}));

// ----------------------------------------------------------------------

export default function EditProfile () {
  return (
    // @ts-ignore
    <RootStyle title="Edit Profile | WakaAfrica Dashboard">

      <Container maxWidth="sm">
        <ContentStyle>
          <Stack sx={{ mb: 2.5 }}>
            <Typography variant="h4" gutterBottom>
              Edit Profile
            </Typography>
          </Stack>

          <EditProfileForm />

        </ContentStyle>
      </Container>
    </RootStyle>
  );
}
